import { styled, css } from 'styled-components';
import Icons from '../Icons/index.js';
export const Group = styled.div `
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
`;
export const Wrapper = styled.div `
  ${({ theme }) => theme.typography.textMedium}
  ${({ theme }) => theme.typography.weightDefault}

  position: relative;
  overflow: hidden;
  white-space: nowrap;
  padding: 2px 8px;

  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  background-color: ${({ theme }) => theme.colors.grey05_2};
  border-radius: 8px;
  box-shadow: inset 0 0 0 1px ${({ theme, $error }) => ($error ? theme.colors.critical10 : theme.colors.grey10_1)};
  color: ${({ theme, $error }) => ($error ? theme.colors.critical100 : theme.colors.black_1)};
  cursor: ${({ onClick, onDoubleClick, $isDisabled }) => (onClick || onDoubleClick ? 'pointer' : $isDisabled ? 'not-allowed' : 'default')};

  ${({ theme, $error, $isDisabled, onClick, onDoubleClick, $isInactive }) => !$isDisabled &&
    (onClick || onDoubleClick) &&
    !$isInactive &&
    css `
      &:hover {
        box-shadow: inset 0 0 0 1px ${$error ? theme.colors.critical30 : theme.colors.grey30_1};
        color: ${$error ? theme.colors.critical100 : theme.colors.blackDark_1};
      }
    `}

  ${({ theme, $error, $isDisabled, $isInactive }) => ($isDisabled || $isInactive) &&
    css `
      background-color: ${$error ? theme.colors.grey01_3 : $isDisabled ? theme.colors.grey30_1 : theme.colors.grey01_2};
      color: ${$error ? theme.colors.critical30 : theme.colors.grey70_1};
      box-shadow: ${$error ? `inset 0 0 0 1px ${theme.colors.critical10}` : `none`};
    `}
`;
export const ClearIcon = styled(Icons.Clear) `
  ${({ $isDisabled }) => !$isDisabled &&
    css `
      cursor: pointer;
    `}
`;
